import { sortBy } from "lodash";
import { DimensionCutoff, ResponseScore } from "../../psyEvaluations.types";
import { RowDimension } from "./scoresTable.types";

export const formatScoreValue = (value: number | string | null | undefined) => {
	if (value == null) return "N/A";
	return `${Number(value)}`;
};

const findMatchingCutoff = (calculatedScore: number | null, cutoffs: Array<DimensionCutoff>) => {
	if (calculatedScore == null) return null;
	const numericScore = Number(calculatedScore);
	const sortedCutoffs = sortBy(cutoffs, (cutoff) => Number(cutoff.value_min ?? Number.POSITIVE_INFINITY));
	const matchedCutoff = sortedCutoffs.find((cutoff) => {
		const minValue = Number(cutoff.value_min);
		const maxValue = Number(cutoff.value_max);
		return Number.isFinite(minValue) && Number.isFinite(maxValue) && numericScore >= minValue && numericScore <= maxValue;
	});
	return matchedCutoff ?? null;
};

export const buildRowDimensions = (scores: Array<ResponseScore>) => {
	const rowsDimensions = scores.map((score) => {
		const cutoffsJunction = score.instrument_dimension?.dimension_cut_offs ?? [];
		const cutoffs = cutoffsJunction.map((junctionRow) => junctionRow.instrument_dimension_cutoffs_id).filter(Boolean);
		const matchedCutoff = findMatchingCutoff(score.calculated_score, cutoffs);
		const rowDimension: RowDimension = {
			instrument_dimension: score.instrument_dimension,
			scores: { id: score.id, raw_score: score.raw_score, calculated_score: score.calculated_score },
			matchedCutoff,
		};
		return rowDimension;
	});
	return rowsDimensions;
};

export const getMatchedColor = (matchedCutoff: DimensionCutoff | null, levelColors: Record<string, string>) => {
	if (!matchedCutoff?.level) return undefined;
	return levelColors[matchedCutoff.level];
};
